import { Skeleton } from '@/components/ui/skeleton';
const LeftMessageSkeleton = () => <div className="flex gap-2 mb-6" data-sentry-component="LeftMessageSkeleton" data-sentry-source-file="chat-loading-skeleton.tsx">
    <div className="space-y-2 w-2/3">
      <Skeleton className="h-8 w-full" data-sentry-element="Skeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
    </div>
  </div>;
const RightMessageSkeleton = () => <div className="flex gap-2 mb-6 justify-end" data-sentry-component="RightMessageSkeleton" data-sentry-source-file="chat-loading-skeleton.tsx">
    <div className="space-y-2 w-2/3">
      <Skeleton className="h-8 w-full" data-sentry-element="Skeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
    </div>
  </div>;
export default function ChatLoadingSkeleton() {
  return <div className="h-dvh overflow-y-hidden flex flex-col" data-sentry-component="ChatLoadingSkeleton" data-sentry-source-file="chat-loading-skeleton.tsx">
      <div className="flex flex-col h-full overflow-y-auto bg-background grow relative">
        {/* Header skeleton */}
        <div className="flex items-center gap-2 p-4">
          <Skeleton className="h-10 w-10 rounded-full" data-sentry-element="Skeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
          <div className="space-y-2">
            <Skeleton className="h-4 w-[150px]" data-sentry-element="Skeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
            <Skeleton className="h-3 w-[100px]" data-sentry-element="Skeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
          </div>
        </div>

        <div className="flex flex-col grow px-4 pt-4 w-full h-full">
          {/* Alternating left and right message skeletons */}
          <LeftMessageSkeleton data-sentry-element="LeftMessageSkeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
          <RightMessageSkeleton data-sentry-element="RightMessageSkeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
          <LeftMessageSkeleton data-sentry-element="LeftMessageSkeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
          <RightMessageSkeleton data-sentry-element="RightMessageSkeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
        </div>
      </div>

      {/* Input skeleton */}
      <div className="w-full bg-background/80 py-4 space-y-2">
        <Skeleton className="h-12 w-full rounded-none" data-sentry-element="Skeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
        <div className="flex justify-center">
          <Skeleton className="h-3 w-24" data-sentry-element="Skeleton" data-sentry-source-file="chat-loading-skeleton.tsx" />
        </div>
      </div>
    </div>;
}